
  import {defineComponent} from "vue";

  export default defineComponent({
    name: "ticket-list-item",
    props: [
        'item',
        'statusClass'
    ]
  });
